import { render, staticRenderFns } from "./Wrap.vue?vue&type=template&id=b45b5a0c&scoped=true&"
import script from "./Wrap.vue?vue&type=script&lang=js&"
export * from "./Wrap.vue?vue&type=script&lang=js&"
import style0 from "./Wrap.vue?vue&type=style&index=0&id=b45b5a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45b5a0c",
  null
  
)

export default component.exports